'use client'

import { useState, useCallback } from 'react'
import { AnnouncementBanner } from './announcement-banner'
import { WhatsNewModal } from './whats-new-modal'
import { dismissAnnouncement } from '@/lib/announcements/announcement-actions'
import type { Announcement } from '@/lib/config/announcements'

interface AnnouncementWrapperProps {
  announcements: Announcement[]
}

export function AnnouncementWrapper({ announcements }: AnnouncementWrapperProps) {
  const [dismissed, setDismissed] = useState<Set<string>>(new Set())

  const handleDismissBanner = useCallback((id: string) => {
    setDismissed((prev) => new Set(prev).add(id))
    dismissAnnouncement(id)
  }, [])

  const handleDismissModal = useCallback((ids: string[]) => {
    setDismissed((prev) => {
      const next = new Set(prev)
      ids.forEach((id) => next.add(id))
      return next
    })
    ids.forEach((id) => dismissAnnouncement(id))
  }, [])

  const active = announcements.filter((a) => !dismissed.has(a.id))
  const bannerAnnouncements = active.filter((a) => !a.isModal)
  const modalAnnouncements = active.filter((a) => a.isModal)

  // Show only the most recent banner
  const topBanner = bannerAnnouncements[0] ?? null

  return (
    <>
      {topBanner && (
        <AnnouncementBanner
          announcement={topBanner}
          onDismiss={handleDismissBanner}
        />
      )}
      {modalAnnouncements.length > 0 && (
        <WhatsNewModal
          announcements={modalAnnouncements}
          onDismiss={handleDismissModal}
        />
      )}
    </>
  )
}
